export default "__VITE_ASSET__BqOoliqy__"